import type { ComponentType } from 'react';
import React from 'react';
import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

interface WithPartnerOnlyProps {
  action?: string | string[];
}

const withPartnerOnly =
  <P extends Record<string, unknown>>(Component: ComponentType<P>) =>
  (props: WithPartnerOnlyProps & P) => {
    const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
    if (!user) return null;

    return <Component {...props} />;
  };

export default withPartnerOnly;
